class MarmetoComparisonHelper {
  static getProducts() {
    return JSON.parse(localStorage.getItem("marmetoCompareProducts")) || [];
  }

  static setProducts(products) {
    localStorage.setItem("marmetoCompareProducts", JSON.stringify(products));
  }

  static addToCompare(productId, productHandle, updateDom) {
    const products = this.getProducts();
    if (!products.some((product) => product.id === productId)) {
      products.push({ id: productId, handle: productHandle });
      this.setProducts(products);
      this.updateCounters(products.length);
      if (updateDom) this.updateCheckboxes();
      // Update button text to "Added to Compare"
      MarmetoComparisonHelper.updateCompareButton(productId, true);
    }
  }

  static removeFromCompare(productId, updateDom) {
    const products = this.getProducts().filter(
      (product) => product.id !== productId,
    );
    this.setProducts(products);
    this.updateCounters(products.length);
    if (updateDom) {
      this.updateCheckboxes();

      document
        .querySelectorAll(`.marmeto-compare-drawer-product-${productId}`)
        .forEach((el) => el.remove());
      document
        .querySelectorAll(`.marmeto-compare-col-${productId}`)
        .forEach((el) => el.remove());
    }
    // Update button text to "Add to Compare"
    MarmetoComparisonHelper.updateCompareButton(productId, false);
  }

  // Add this new static method to update the button text
  static updateCompareButton(productId, isInCompare) {
    document.querySelectorAll('.js-pdp-compare-button').forEach((btn) => {
      if (Number(btn.dataset.productId) === Number(productId)) {
        btn.textContent = isInCompare ? "Added to Compare" : "Add to Compare";
        btn.classList.toggle("is--active", isInCompare);
      }
    });
  }

  static getCount() {
    return this.getProducts().length;
  }

  static updateCounters(count = this.getCount()) {
    document
      .querySelectorAll(".js-compare-product-count")
      .forEach((counter) => (counter.innerText = count));
  }

  static updateCheckboxes() {
    const products = this.getProducts();
    document.querySelectorAll(".js-compare-input").forEach((checkbox) => {
      checkbox.checked = products.some(
        (product) => product.id === checkbox.dataset.productId,
      );
    });
  }

  static clearCompare(updateDom) {
    const products = this.getProducts();
    products.forEach((product) =>
      this.removeFromCompare(product.id, updateDom),
    );
  }
}

class MarmetoComparisonSwitch extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.compareSwitches = document.querySelectorAll(
      '[name="marmeto-comparison-switch"]',
    );
    this.productGrid = document.querySelector(".container--main-collection");
    const isCompareEnabled = JSON.parse(
      localStorage.getItem("marmetoCompareEnabled"),
    );

    console.log(isCompareEnabled);

    this.updateCompareState(
      isCompareEnabled !== null ? isCompareEnabled : false,
      false,
    );

    // Attach event listeners to all switches
    this.compareSwitches.forEach((switchElement) => {
      switchElement.addEventListener("change", (event) =>
        this.toggleCompare(event),
      );
    });
  }

  toggleCompare(event) {
    const isChecked = event.target.checked;
    this.updateCompareState(isChecked);
  }

  updateCompareState(isChecked, persist = true) {
    this.productGrid.dataset.compareEnabled = isChecked;

    this.compareSwitches.forEach((switchElement) => {
      switchElement.checked = isChecked;
    });

    if (persist && !Shopify.designMode) {
      localStorage.setItem("marmetoCompareEnabled", isChecked);
    }

    const compareDrawer = document.querySelector(".js-compare-drawer-open");
    if (compareDrawer) {
      compareDrawer.classList.toggle("is--hidden", !isChecked);
    }
  }
}

customElements.define("marmeto-comparison-switch", MarmetoComparisonSwitch);

class MarmetoComparisonDrawer extends HTMLElement {
  constructor() {
    super();
    this.setupElements();
    this.maximumComparisonAllowed = this.dataset.maximumComparisonAllowed;

    this.initialize();
    this.bindEvents();
  }

  setupElements() {
    const elementMap = {
      drawer: "js-compare-drawer",
      overlay: "js-compare-drawer-overlay",
      loader: "js-compare-drawer-loader",
      openButton: "js-compare-drawer-open",
      closeButton: "js-compare-drawer-close",
      clearButton: "js-compare-clear",
      submitButton: "js-compare-popup-open",
    };

    Object.keys(elementMap).forEach((key) => {
      this[key] = document.querySelector(`.${elementMap[key]}`);
    });

    this.productHolder = document.querySelector(".js-compare-drawer-products");
    this.comparePopup = document.querySelector(".js-compare-popup");
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.clickEventHandler);
    document.removeEventListener("change", this.changeEventHandler);
  }

  initialize() {
    MarmetoComparisonHelper.updateCheckboxes();
    MarmetoComparisonHelper.updateCounters();
    this.updateCompareDrawerElements();
  }

  bindEvents() {
    this.clickEventHandler = this.handleClickEvent.bind(this);
    this.changeEventHandler = this.handleChangeEvent.bind(this);

    document.addEventListener("click", this.clickEventHandler);
    document.addEventListener("change", this.changeEventHandler);
    this.submitButton.addEventListener(
      "click",
      this.submitButtonClick.bind(this),
    );
  }

  handleClickEvent(event) {
    const { target } = event;

    if (target === this.openButton) {
      if (target.classList.contains("is--opened")) {
        this.renderCompareDrawerProducts(); 
      } else {
        this.openDrawer();
      }
    } else if (target === this.clearButton) {
      MarmetoComparisonHelper.clearCompare(true);
      this.closeDrawer();
    } else if (target.classList.contains("js-compare-drawer-remove")) {
      MarmetoComparisonHelper.removeFromCompare(target.dataset.productId, true);
      this.updateCompareDrawerElements();
    } else if ([this.overlay, this.closeButton].includes(target)) {
      this.closeDrawer();
    }
  }

  handleChangeEvent({ target }) {
    if (target.classList.contains("js-compare-input")) {
      const { productId, productHandle } = target.dataset;
      if (target.checked) {
        if (MarmetoComparisonHelper.getCount() < this.maximumComparisonAllowed) {
          MarmetoComparisonHelper.addToCompare(productId, productHandle, false);
        } else {
          target.checked = false;
          if (window.csToast) {
            window.csToast.showToast(
              'warning',
              `You can only add a maximum of ${this.maximumComparisonAllowed} products to compare.`
            );
          }
        }
      } else {
        MarmetoComparisonHelper.removeFromCompare(productId, false);
      }
      this.updateCompareDrawerElements();
    }
  }

  openDrawer() {
    ["openButton", "overlay", "drawer"].forEach((el) =>
      this[el].classList.add("is--opened"),
    );
    this.drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow--hidden");
    this.renderCompareDrawerProducts();
  }

  closeDrawer() {
    ["openButton", "overlay", "drawer"].forEach((el) =>
      this[el].classList.remove("is--opened"),
    );
    this.drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow--hidden");
  }

  submitButtonClick() {
    const compareProductCount = MarmetoComparisonHelper.getCount();

    if (compareProductCount < 2) return;
    this.closeDrawer();
    this.comparePopup.dispatchEvent(
      new CustomEvent("marmeto-compare-modal:open"),
      { bubbles: true },
    );
  }

  updateCompareDrawerElements() {
    const compareProductCount = MarmetoComparisonHelper.getCount();
    this.submitButton.toggleAttribute("disabled", compareProductCount < 2);
    this.productHolder.querySelector(".js-compare-drawer-notice")?.remove();

    if (compareProductCount < 2) {
      this.productHolder.innerHTML += `<div class="marmeto-compare-drawer__notice js-compare-drawer-notice">Select at least 2 products to compare</div>`;
    }
  }

  async renderCompareDrawerProducts() {
    const products = MarmetoComparisonHelper.getProducts();
    if (products) {
      this.productHolder.innerHTML = "";
      this.loader.removeAttribute("hidden");
      const compareProductHtmlArr =
        await MarmetoComparisonDrawer.getCompareDrawerProducts(products);
      this.productHolder.innerHTML = compareProductHtmlArr.join("");
      setTimeout(() => {
        this.updateCompareDrawerElements();
        this.loader.setAttribute("hidden", "true");
      }, 150);
    }
  }

  static async getCompareDrawerProducts(products) {
    const productHtmlArray = await Promise.all(
      products.map(({ handle }) =>
        fetch(`/products/${handle}?sections=marmeto-compare-drawer-products`)
          .then((response) => response.json())
          .then((data) => data["marmeto-compare-drawer-products"]),
      ),
    );
    return productHtmlArray;
  }
}

customElements.define("marmeto-comparison-drawer", MarmetoComparisonDrawer);

class MarmetoComparisonPopup extends HTMLElement {
  constructor() {
    super();
    this.setupElements();
    this.bindEvents();
  }

  setupElements() {
    const elementMap = {
      popup: "js-compare-popup",
      loader: "js-compare-popup-loader",
      closeButton: "js-compare-popup-close",
      removeButton: "js-compare-popup-remove",
      productHolder: "js-compare-popup-products",
    };

    Object.keys(elementMap).forEach((key) => {
      this[key] = document.querySelector(`.${elementMap[key]}`);
    });
  }

  disconnectedCallback() {
    document.removeEventListener("focusin", this.clickEventHandler);
  }

  bindEvents() {
    this.clickEventHandler = this.handleClickEvent.bind(this);

    document.addEventListener("click", this.clickEventHandler);
    this.addEventListener(
      "marmeto-compare-modal:open",
      this.openPopup.bind(this),
    );
    this.closeButton.addEventListener("click", this.closePopup.bind(this));
  }

  handleClickEvent(event) {
    const { target } = event;

    if (target.classList.contains("js-compare-popup-remove")) {
      MarmetoComparisonHelper.removeFromCompare(target.dataset.productId, true);

      const compareProductCount = MarmetoComparisonHelper.getCount();
      if (compareProductCount === 1) this.closePopup();
    }
  }

  openPopup() {
    this.classList.add("is--opened");
    this.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow--hidden");
    this.renderComparePopupProducts();
  }

  closePopup() {
    this.classList.remove("is--opened");
    this.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow--hidden");
  }

  async renderComparePopupProducts() {
    this.productHolder.innerHTML = "";
    this.loader.removeAttribute("hidden");
    const products = MarmetoComparisonHelper.getProducts();

    if (products) {
      const productHtmlArray =
        await MarmetoComparisonPopup.getComparePopupProducts(products);
      const comparisonFields = {};

      productHtmlArray.forEach((html) => {
        const parsedDocument = new DOMParser().parseFromString(
          html,
          "text/html",
        );
        parsedDocument
          .querySelectorAll(".shopify-section > div")
          .forEach((field) => {
            if (!comparisonFields[field.dataset.compareKey]) {
              comparisonFields[field.dataset.compareKey] = [];
            }
            comparisonFields[field.dataset.compareKey].push(field);
          });
      });

      const comparisonContainer = document.createElement("div");
      comparisonContainer.className = "compare-temp";

      let actionsElements = [];

      Object.entries(comparisonFields).forEach(([fieldKey, fieldValues]) => {
        const fieldRow = document.createElement("div");
        fieldRow.className = `marmeto-compare-row marmeto-compare-row--${fieldKey.includes("metafield") ? "metafield" : fieldKey.replace("marmeto-compare-", "")}`;

        fieldValues.forEach((elem) => {
          if (
            elem.getAttribute("data-compare-key") === "marmeto-compare-actions"
          ) {
            actionsElements.push(elem);
          }
          fieldRow.appendChild(elem);
        });

        comparisonContainer.appendChild(fieldRow);
      });

      const actionRow = document.createElement("div");
      actionRow.className = "marmeto-compare-row marmeto-compare-row--actions";

      actionsElements.forEach((actionElem) => {
        actionRow.appendChild(actionElem);
        comparisonContainer.appendChild(actionRow);
      });

      this.productHolder.innerHTML =
        comparisonContainer.innerHTML ||
        `<div class="marmeto-compare-popup__notice">Unable to compare products. Please try again later.</div>`;
      setTimeout(() => this.loader.setAttribute("hidden", "true"), 150);
    }
  }

  static async getComparePopupProducts(products) {
    return await Promise.all(
      products.map(({ handle }) =>
        fetch(`/products/${handle}?sections=marmeto-compare-popup-products`)
          .then((response) => response.json())
          .then((data) => data["marmeto-compare-popup-products"]),
      ),
    );
  }
}

customElements.define("marmeto-comparison-popup", MarmetoComparisonPopup);
